import { CalloutBox } from 'components/Docs/CalloutBox';
import DistinctIdReuseWarning from "../../../../contents/docs/privacy/_snippets/distinct-id-reuse-warning.mdx";
import * as React from 'react';
export default {
  CalloutBox,
  DistinctIdReuseWarning,
  React
};